module.exports = __webpack_public_path__ + "static/media/aboutArchitecture.f4cf51ca.svg";